import { Col } from 'react-bootstrap'

const ProjectCard = ({ title, description, techStack, imgUrl, websiteUrl }) => {
    return (
        <Col size={12} sm={6} md={4}>
            {console.log(websiteUrl, "weburl")}
            <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
                <div className="proj-imgbx">
                    <img src={imgUrl} />
                    <div className="proj-txtx">
                        <h4>{title}</h4>
                        <span>{description}</span>
                        {
                            techStack.length > 0 &&
                            <div className="tech-stack">
                                <h5>Technology :</h5>
                                {techStack.map((tech, index) => (
                                    <span key={index}>
                                        {tech}{index < techStack.length - 1 && ","}
                                    </span>
                                ))}
                            </div>
                        }

                    </div>
                </div>
            </a>
        </Col>
    )
}

export default ProjectCard